import React, { useMemo } from "react";

export default function SuppliersMarquee({
  suppliers,
  speedSeconds = 28, // menor = mais rápido
  logoHeight = 56,   // altura do logo
}) {
  // duplica pra virar “loop infinito”
  const items = useMemo(() => [...suppliers, ...suppliers], [suppliers]);

  return (
    <section className="py-10 bg-white" data-testid="suppliers-marquee">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <h2
            className="text-2xl md:text-3xl font-bold"
            style={{ color: "#273e82", fontFamily: "Manrope" }}
          >
            Nossos fornecedores
          </h2>
          <p className="text-slate-600 mt-1">
            Marcas e parceiros com quem trabalhamos.
          </p>
        </div>

        <div className="relative overflow-hidden rounded-xl bg-white shadow-[0_10px_30px_rgba(0,0,0,0.08)]">
          {/* sombras laterais (igual referência) */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10" />

          {/* faixa */}
          <div className="py-10">
            <div
              className="flex items-center gap-14 w-max animate-suppliers-marquee hover:[animation-play-state:paused]"
              style={{ animationDuration: `${speedSeconds}s` }}
            >
              {items.map((s, idx) => (
                <a
                  key={`${s.name}-${idx}`}
                  href={s.href || "#"}
                  target={s.href ? "_blank" : undefined}
                  rel={s.href ? "noopener noreferrer" : undefined}
                  className="group flex items-center justify-center"
                  aria-label={s.name}
                  title={s.name}
                >
                  <div className="w-[150px] h-[70px] flex items-center justify-center">
                    <img
                      src={s.logo}
                      alt={s.name}
                      draggable="false"
                      className="
      max-h-[50px]
      max-w-[120px]
      object-contain
      grayscale
      opacity-70
      transition-all
      duration-200
      group-hover:grayscale-0
      group-hover:opacity-100
    "
                    />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* CSS local pro keyframes */}
        <style>
          {`
            @keyframes suppliers-marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            .animate-suppliers-marquee {
              animation-name: suppliers-marquee;
              animation-timing-function: linear;
              animation-iteration-count: infinite;
            }
          `}
        </style>
      </div>
    </section>
  );
}